<template>
  <div>
    <v-card class="overflow-hidden">
      <v-card-text>
        <v-row>
          <v-col>
            <customer-autocomplete-filter
              :fatherEditedCustomer="filterResume"
              :editedCustomerIndex="-1"
              :customerName="'quotation_shortname'"
              @setFilterCustomer="setFilterCustomer"
            />
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('quotation_license_plate')"
              v-model="filterResume.LicensePlate"
              @input="getResume"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-data-table
      :headers="ResumeDataTableHeaders"
      :items="resumeList"
      class="elevation-1 my-5"
      :loading="isLoadingResume"
      :loading-text="$t('common_get_data')"
      :no-data-text="$t('common_no_data')"
      :no-results-text="$t('common_no_results')"
      :footer-props="{
        'items-per-page-options': [30, 50, 100],
        'items-per-page-text': $t('item_rows_per_page'),
      }"
      :server-items-length="totalRows"
      :options="currentOptions"
      @update:options="updateOptions"
      :header-props="headerProps"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ $t('resume_tool_bar_title') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-dialog v-model="isShowResumeDialog" fullscreen>
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ $t('resume_card_title') }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="4" lg="4" xl="4">
                      <v-text-field
                        v-model="lookResume.CustomerNumber"
                        :label="$t('quotation_customer_number')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" lg="4" xl="4">
                      <v-text-field
                        v-model="lookResume.CustomerName"
                        :label="$t('quotation_shortname')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" lg="4" xl="4">
                      <v-text-field
                        v-model="lookResume.CustomerFullName"
                        :label="$t('quotation_full_name')"
                        disabled
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="4" lg="4" xl="4">
                      <v-text-field
                        v-model="lookResume.LicensePlate"
                        :label="$t('quotation_license_plate')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" lg="4" xl="4">
                      <v-autocomplete
                        :items="allSpecialNeedList"
                        item-text="Name"
                        item-value="Name"
                        :label="$t('quotation_special_need')"
                        disabled
                        v-model="lookResume.SpecialNeedList"
                        :loading-text="$t('common_get_data')"
                        :no-data-text="$t('common_no_results')"
                        small-chips
                        multiple
                        return-object
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" lg="4" xl="4">
                      <v-text-field v-model="lookResume.Brand" disabled label="廠牌/車型">
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="2" sm="2" md="2" lg="2" xl="2" class="blue--text">
                      {{ $t('engineer_first_contact') }}
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="lookResume.FirstContactName"
                        :label="$t('installation_notice_contact_name')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="lookResume.FirstContactPhone"
                        :label="$t('installation_notice_contact_name')"
                        disabled
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="2" sm="2" md="2" lg="2" xl="2" class="blue--text">
                      {{ $t('engineer_second_contact') }}
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="lookResume.SecondContactName"
                        :label="$t('installation_notice_contact_name')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="lookResume.SecondContactPhone"
                        :label="$t('installation_notice_contact_name')"
                        disabled
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="2" sm="2" md="2" lg="2" xl="2" class="blue--text">
                      {{ $t('engineer_third_contact') }}
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="lookResume.ThirdContactName"
                        :label="$t('installation_notice_contact_name')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <v-text-field
                        v-model="lookResume.ThirdContactPhone"
                        :label="$t('installation_notice_contact_name')"
                        disabled
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-data-table
                :headers="ResumeItemDataTableHeaders"
                :items="lookResume.ResumeItems"
                class="elevation-1 mx-5"
                :loading-text="$t('common_get_data')"
                :no-data-text="$t('common_no_data')"
                :no-results-text="$t('common_no_results')"
                :footer-props="{
                  'items-per-page-options': [30, 50, 100],
                  'items-per-page-text': $t('item_rows_per_page'),
                }"
                :header-props="headerProps"
                :search="searchResumeItem"
                :item-class="isOutOfWarrantyClass"
              >
                <template v-slot:top>
                  <v-toolbar flat>
                    <v-toolbar-title>{{ $t('resume_item_tool_bar_title') }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="searchResumeItem"
                      append-icon="mdi-magnify"
                      :label="$t('resume_item_search_label')"
                      single-line
                      hide-details
                      clearable
                    ></v-text-field>
                    <v-dialog v-model="isShowResumeItemProcessDialog" max-width="1000px">
                      <v-card>
                        <v-card-title>
                          <span class="text-h5">{{ $t('resume_item_process_card_title') }}</span>
                        </v-card-title>
                        <v-data-table
                          :headers="resumeItemProcessesDataTableHeaders"
                          :items="lookResumeItem.Processes"
                          class="elevation-1 mx-5"
                          :loading-text="$t('common_get_data')"
                          :no-data-text="$t('common_no_data')"
                          :no-results-text="$t('common_no_results')"
                          :footer-props="{
                            'items-per-page-options': [30, 50, 100],
                            'items-per-page-text': $t('item_rows_per_page'),
                          }"
                          :header-props="headerProps"
                          :search="searchResumeItemProcess"
                        >
                          <template v-slot:top>
                            <v-toolbar flat>
                              <v-spacer></v-spacer>
                              <v-text-field
                                v-model="searchResumeItemProcess"
                                append-icon="mdi-magnify"
                                :label="$t('resume_item_process_search_label')"
                                single-line
                                hide-details
                                clearable
                              ></v-text-field>
                            </v-toolbar>
                          </template>
                          <template v-slot:[`item.CreateDate`]="{ item }">
                            {{ convertToDateTimeFormat(item.CreateDate) }}
                          </template>
                          <template v-slot:[`item.StartTime`]="{ item }">
                            {{ convertToDateTimeFormat(item.StartTime) }}
                          </template>
                          <template v-slot:[`item.EndTime`]="{ item }">
                            {{ convertToDateTimeFormat(item.EndTime) }}
                          </template>
                          <template v-slot:[`item.OriginalNumberType`]="{ item }">
                            {{ turnNumberTypeData(item.OriginalNumberType) }}
                          </template>
                          <template v-slot:[`item.NumberType`]="{ item }">
                            {{ turnNumberTypeData(item.NumberType) }}
                          </template>
                          <template v-slot:[`item.WorkType`]="{ item }">
                            {{ turnWorkTypeName(item.WorkType) }}
                          </template>
                        </v-data-table>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="red darken-1" text @click="closeLookResumeItemProcess">
                            {{ $t('common_close') }}
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-toolbar>
                </template>
                <!-- <template v-slot:[`item.UpdateTime`]="{ item }">
                {{ convertToDateTimeFormat(item.UpdateTime) }}
                </template> -->
                <template v-slot:[`item.Edit`]="{ item }">
                  <v-btn icon @click="isShowLookResumeItemProcessBtn(item)">
                    <v-icon small>
                      mdi-eye
                    </v-icon>
                  </v-btn>
                </template>
                <template v-slot:[`item.InstallPosition`]="{ item }">
                  {{ turnData(item.InstallPosition) }}
                </template>
                <template v-slot:[`item.RemoveDate`]="{ item }">
                  {{ convertToDateTimeFormat(item.RemoveDate) }}
                </template>
                <template v-slot:[`item.BuyStartDate`]="{ item }">
                  {{ convertToDateTimeFormat(item.BuyStartDate) }}
                </template>
                <template v-slot:[`item.BuyEndDate`]="{ item }">
                  {{ convertToDateTimeFormat(item.BuyEndDate) }}
                </template>
                <template v-slot:[`item.BuyOrRentType`]="{ item }">
                  {{ turnBuyOrRentType(item.BuyOrRentType) }}
                </template>
                <template v-slot:[`item.Custody`]="{ item }">
                  {{ turnCustodyTypeData(item.Custody) }}
                </template>
                <template v-slot:[`item.CustomerDeviceType`]="{ item }">
                  {{ turnCustomerDeviceTypeData(item.CustomerDeviceType) }}
                </template>
                <template v-slot:[`item.IsCustomerDevice`]="{ item }">
                  <v-icon v-if="item.IsCustomerDevice">
                    mdi-check
                  </v-icon>
                  <v-icon v-else>
                    mdi-window-close
                  </v-icon>
                </template>
              </v-data-table>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" text @click="closeLookResumeItem">
                  {{ $t('common_close') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <!-- <template v-slot:[`item.UpdateTime`]="{ item }">
      {{ convertToDateTimeFormat(item.UpdateTime) }}
    </template> -->
      <template v-slot:[`item.Edit`]="{ item }">
        <v-btn icon @click="isShowLookResumeBtn(item)">
          <v-icon small>
            mdi-eye
          </v-icon>
        </v-btn>
      </template>
      <template v-slot:[`item.SpecialNeedList`]="{ item }">
        {{ turnSpecialNeedName(item.SpecialNeedList) }}
      </template>
    </v-data-table>
  </div>
</template>
<style scoped>
.red {
  background-color: red !important;
}
</style>
<script>
import { HttpResume, HttpSpecialNeed, HttpInstallPosition } from '@/js/http-Manager'
import { ItemInstallPositionType } from '@/js/ItemInstallPositionType'
import axios from 'axios'
import CustomerAutocompleteFilter from '@/components/CustomerAutocompleteFilter.vue'
import { NumberType } from '@/js/NumberType'
import { BuyOrRentType } from '@/js/BuyOrRentType'
import { CustodyType } from '@/js/CustodyType'
import { CustomerDeviceType } from '@/js/CustomerDeviceType'
import { WorkType } from '@/js/WorkType'

export default {
  components: { CustomerAutocompleteFilter },
  name: 'Resume',
  data: () => ({
    filterResume: {
      CustomerId: '',
      LicensePlate: ''
    },
    isShowResumeDialog: false,
    resumeList: [],
    lookResumeIndex: -1,
    searchResume: '',
    lookResume: {
      CustomerId: '',
      CustomerNumber: '',
      CustomerName: '',
      CustomerFullName: '',
      LicensePlate: '',
      FirstContactName: '',
      FirstContactPhone: '',
      SecondContactName: '',
      SecondContactPhone: '',
      ThirdContactName: '',
      ThirdContactPhone: '',
      ResumeItems: [],
      SpecialNeedList: [],
      Brand: ''
    },
    defaultResume: {
      CustomerId: '',
      CustomerNumber: '',
      CustomerName: '',
      CustomerFullName: '',
      LicensePlate: '',
      FirstContactName: '',
      FirstContactPhone: '',
      SecondContactName: '',
      SecondContactPhone: '',
      ThirdContactName: '',
      ThirdContactPhone: '',
      ResumeItems: [],
      SpecialNeedList: [],
      Brand: ''
    },
    isLoadingResume: true,
    totalRows: 0,
    isUpdateEventTotal: true,
    currentOptions: {
      // default DataTable Options
      page: 1,
      itemsPerPage: 30,
      sortBy: [],
      sortDesc: [],
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: false,
      triggerByOutsite: true
    },
    lookResumeItem: {
      Processes: []
    },
    defaultResumeItem: {
      Processes: []
    },
    resumeSource: null,
    isShowResumeItemProcessDialog: false,
    searchResumeItem: '',
    lookResumeItemProcessIndex: -1,
    searchResumeItemProcess: '',
    allSpecialNeedList: [],
    installPositionList: []
  }),
  async mounted () {
    await this.getResume()
    await this.countTotalRows()
    await this.getSpecialNeedList()
    await this.getInstallPositionList()
  },
  watch: {},
  computed: {
    ResumeDataTableHeaders () {
      return [
        { text: this.$t('quotation_customer_number'), align: 'start', value: 'CustomerNumber' },
        { text: this.$t('quotation_shortname'), align: 'start', value: 'CustomerName' },
        { text: this.$t('quotation_full_name'), align: 'start', value: 'CustomerFullName' },
        { text: this.$t('quotation_license_plate'), align: 'start', value: 'LicensePlate' },
        {
          text: this.$t('quotation_special_need'),
          align: 'start',
          value: 'SpecialNeedList'
        },
        { text: this.$t('common_look'), align: 'center', value: 'Edit', sortable: false }
      ]
    },
    ResumeItemDataTableHeaders () {
      return [
        { text: this.$t('installation_notice_item_main_name'), align: 'start', value: 'BomName' },
        { text: this.$t('quotation_item_number'), align: 'start', value: 'Number' },
        { text: this.$t('quotation_item_name'), align: 'start', value: 'Name' },
        { text: this.$t('quotation_item_unit'), align: 'start', value: 'Unit' },
        { text: this.$t('quotation_item_quantity'), align: 'end', value: 'Quantity' },
        {
          text: this.$t('installation_notice_item_buy_or_rent'),
          align: 'start',
          value: 'BuyOrRentType'
        },
        {
          text: this.$t('quotation_item_serialnumber'),
          align: 'start',
          value: 'SerialNumber.Number'
        },
        {
          text: this.$t('quotation_item_is_customer_device'),
          align: 'start',
          value: 'IsCustomerDevice'
        },
        {
          text: this.$t('quotation_item_is_customer_device') + 'Type',
          align: 'start',
          value: 'CustomerDeviceType'
        },
        {
          text: this.$t('quotation_item_install_position'),
          align: 'start',
          value: 'InstallPosition'
        },
        { text: this.$t('resume_item_remove_date'), align: 'start', value: 'RemoveDate' },
        { text: this.$t('resume_item_buy_start'), align: 'start', value: 'BuyStartDate' },
        { text: this.$t('resume_item_buy_end'), align: 'start', value: 'BuyEndDate' },
        {
          text: this.$t('quotation_original_license_plate'),
          align: 'start',
          value: 'OriginalLicensePlate'
        },
        { text: this.$t('resume_item_custody'), align: 'start', value: 'Custody' },
        { text: this.$t('quotation_item_remark'), align: 'start', value: 'Remark' },
        { text: this.$t('common_look'), align: 'center', value: 'Edit', sortable: false }
      ]
    },
    resumeItemProcessesDataTableHeaders () {
      return [
        {
          text: this.$t('quotation_customer_number'),
          align: 'start',
          value: 'CustomerNumber'
        },
        {
          text: this.$t('quotation_shortname'),
          align: 'start',
          value: 'CustomerName'
        },
        {
          text: this.$t('quotation_full_name'),
          align: 'start',
          value: 'CustomerFullName'
        },
        {
          text: '回寫單據單別',
          align: 'start',
          value: 'OriginalNumberType'
        },
        {
          text: this.$t('resume_item_process_original_number'),
          align: 'start',
          value: 'OriginalNumber'
        },
        { text: this.$t('resume_item_process_quantity'), align: 'start', value: 'Quantity' },
        {
          text: this.$t('quotation_item_serialnumber'),
          align: 'start',
          value: 'SerialNumber.Number'
        },
        { text: this.$t('resume_item_process_create_date'), align: 'start', value: 'CreateDate' },
        {
          text: this.$t('resume_item_process_number_type'),
          align: 'start',
          value: 'NumberType'
        },
        {
          text: this.$t('resume_item_process_flow_original_number'),
          align: 'start',
          value: 'FlowOriginalNumber'
        },
        {
          text: this.$t('resume_item_buy_start'),
          align: 'start',
          value: 'StartTime'
        },
        {
          text: this.$t('resume_item_buy_end'),
          align: 'start',
          value: 'EndTime'
        },
        {
          text: this.$t('quotation_item_remark'),
          align: 'start',
          value: 'Remark'
        },
        {
          text: this.$t('engineer_item_work_type'),
          align: 'start',
          value: 'WorkType'
        }
      ]
    },
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    }
  },
  methods: {
    async getInstallPositionList () {
      let response = await HttpInstallPosition.GetAllInstallPosition()
      this.installPositionList = response && response.status === 200 ? response.data.Data : []
    },
    turnSpecialNeedName (value) {
      if (value) {
        let str = []
        let temp = 0
        value.forEach((element) => {
          str.push(element.Name)
          temp++
        })
        str = JSON.stringify(str)
        str = str.replace('[', '').replace(']', '')
        for (let index = 0; index < temp * 2; index++) {
          str = str.replace('"', '')
        }
        return str
      }
    },
    async getSpecialNeedList () {
      let response = await HttpSpecialNeed.GetSpecialNeed()
      this.allSpecialNeedList = response.status === 200 ? response.data.Data : []
    },
    isOutOfWarrantyClass (item) {
      let now = new Date()
      if (item.BuyEndDate < now && item.BuyOrRentType === 1) {
        return 'red'
      }
    },
    turnCustomerDeviceTypeData (val) {
      return CustomerDeviceType.CustomerDeviceTypeName(val)
    },
    turnCustodyTypeData (val) {
      return CustodyType.CustodyTypeName(val)
    },
    turnBuyOrRentType (val) {
      return BuyOrRentType.BuyOrRentTypeName(val)
    },
    turnNumberTypeData (val) {
      return NumberType.NumberTypeName(val)
    },
    turnWorkTypeName (val) {
      return WorkType.getFormWorkTypeName(val)
    },
    async setFilterCustomer (val) {
      this.filterResume.CustomerId = val.Id
      this.filterResume = JSON.parse(JSON.stringify(this.filterResume))
      await this.getResume()
      await this.countTotalRows()
    },
    async countTotalRows () {
      if (this.isUpdateEventTotal) {
        let param = {
          customerId: this.filterResume.CustomerId,
          licensePlate: this.filterResume.LicensePlate
        }
        let response = await HttpResume.GetResumeCount(param)
        this.totalRows = response.status === 200 ? response.data.Data : 0
      }
    },
    updateOptions (val) {
      this.currentOptions = val
      this.isUpdateEventTotal = false
      this.getResume(val)
    },
    async getResume (val) {
      if (this.isUpdateEventTotal) {
        this.currentOptions.page = 1
        this.countTotalRows()
      }
      this.isUpdateEventTotal = true
      this.isLoadingResume = true
      let param = {
        CustomerId: this.filterResume.CustomerId,
        LicensePlate: this.filterResume.LicensePlate,
        PerPage:
          typeof val === 'object' && val ? val.itemsPerPage : this.currentOptions.itemsPerPage,
        Page: typeof val === 'object' && val ? val.page : this.currentOptions.page,
        SortBy: typeof val === 'object' && val ? val.sortBy[0] : this.currentOptions.sortBy[0],
        SortDesc: typeof val === 'object' && val ? val.sortDesc[0] : this.currentOptions.sortBy[0]
      }
      if (this.resumeSource) {
        this.resumeSource.cancel('cancel')
      }
      let cancelToken = axios.CancelToken
      this.resumeSource = cancelToken.source()
      let response = await HttpResume.GetResume(param, this.resumeSource.token)
      this.isLoadingResume = false
      if (response) {
        this.resumeList = response.status === 200 ? response.data.Data : []
        this.resumeSource = null
      }
    },
    convertToDateTimeFormat (timestamp) {
      if (timestamp === 0) {
        return '-'
      } else {
        return this.$moment(new Date(timestamp)).format('YYYY-MM-DD')
      }
    },
    isShowLookResumeBtn (item) {
      this.lookResumeIndex = this.resumeList.indexOf(item)
      let str = JSON.stringify(item)
      this.lookResume = JSON.parse(str)
      this.isShowResumeDialog = true
    },
    async closeLookResumeItem () {
      await this.getResume()
      this.isShowResumeDialog = false
      this.$nextTick(() => {
        let str = JSON.stringify(this.defaultResume)
        this.lookResume = JSON.parse(str)
        this.lookResumeIndex = -1
      })
    },

    isShowLookResumeItemProcessBtn (item) {
      this.lookResumeItemProcessIndex = this.lookResume.ResumeItems.indexOf(item)
      let str = JSON.stringify(item)
      this.lookResumeItem = JSON.parse(str)
      this.isShowResumeItemProcessDialog = true
    },
    async closeLookResumeItemProcess () {
      this.isShowResumeItemProcessDialog = false
      this.$nextTick(() => {
        let str = JSON.stringify(this.defaultResumeItem)
        this.lookResumeItem = JSON.parse(str)
        this.lookResumeItemProcessIndex = -1
      })
    },
    turnData (value) {
      if (value) {
        return ItemInstallPositionType.getFormInstallPositionTypeName(
          value,
          this.installPositionList
        )
      }
    }
  }
}
</script>
